import React from 'react';
import {ActivityIndicator} from '@bosch/react-frok';
import {Container} from './LoadingIndicator.style';
import {generateIdentifier} from '../../utils/IdentityUtils';

/**
 * @name LoadingIndicator
 * @description
 * A centered indicator for showing a loading state
 */
export const LoadingIndicator: React.VFC = () => {
    return (
        <Container id={generateIdentifier()}>
            <ActivityIndicator/>
        </Container>
    );
};
